export default __webpack_public_path__ + "../ckeditor/plugins/pastefromword/filter/default.js";